<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("Tax") }} {{ $t("types") }}</div>
        <div class="section-subTitle my-2">
          {{ $t("chargetypes_dash_msg") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Charge Types')"
          variant="default"
          to="add-tax-type"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          @input="searchChargeTypesList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                getChargeTypesList(filterIsActive);
              }
            "
          />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="ChargeTypes.length > 0"
        v-for="(item, key) in ChargeTypes"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.ct_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Charge Types')"
                  @click="goToRoute('/master/edit-tax-type', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-tax-type', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot :status="item.ct_is_active ? 'active' : 'inactive'" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="ChargeTypes.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'ct_name'"
              @click="onSortValue('ct_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('ct_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('ct_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("chargetypes", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="ChargeTypes.length > 0">
        <tr v-for="(item, key) in ChargeTypes" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot :status="item.ct_is_active ? 'active' : 'inactive'" />
              <span
                v-if="$can('update', 'Charge Types')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/master/edit-tax-type', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
              <span
                class="view-icon ml-2 blue-icon"
                @click="goToRoute('/master/view-tax-type', item)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td>{{ $tc(item.ct_name, 1) }}</td>
        </tr>
      </tbody>
      <tbody v-if="ChargeTypes.length == 0">
        <tr>
          <td colspan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="ChargeTypes.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ChargeTypes from "@/helper/formJSONMaster/ChargeTypes";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: ChargeTypes.Methods,
      ChargeTypes: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      searchValue: "",
      // filter_is_active_label: 'Active',
      // filter_is_active: "Y"
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.getChargeTypesList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getChargeTypesList();
      } else {
        this.currentPage = event;
        this.getChargeTypesList();
      }
    },
    goToRoute: function (path, item) {
      const { ct_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: ct_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getChargeTypesList();
    },
    searchChargeTypesList: function (search) {
      this.getChargeTypesList(undefined, 1, search);
    },
    getChargeTypesList: function (
      filterIsActive = "Y",
      page = undefined,
      search = undefined
    ) {
      this.ChargeTypes = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&filter_is_active=${filterIsActive}`;
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.ChargeTypes = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ChargeTypesComponents/chargeTypes.vue